// extracted by mini-css-extract-plugin
export default {"appWrapper":"Layout_appWrapper__oPJDT","contentWrapper":"Layout_contentWrapper__fC43W"};